import { render, staticRenderFns } from "./SelectExpirationType.vue?vue&type=template&id=1935ffc4&scoped=true&"
import script from "./SelectExpirationType.vue?vue&type=script&lang=js&"
export * from "./SelectExpirationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1935ffc4",
  null
  
)

export default component.exports
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QSelect});
